import styled from '@emotion/styled';

import { TablePanel } from '@/components/common/Panel/style';
import { pageSectionLayout } from '@/styles/pageLayout';

export { TablePanel };

export const ExecutiveListContainer = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const ExecutiveListItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ExecutiveListTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: minmax(40px, auto);
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: ${(props) => props.theme.lineHeight.normal};
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212529;
	word-break: keep-all;
	overflow-wrap: anywhere;
	&.point {
		color: ${(props) => props.theme.colors.primary400};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
	&.role-cell {
		align-self: stretch;
	}
`;
export const PositionCell = styled(TableCell)`
	color: ${(props) => props.theme.colors.primary400};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
`;
